module.exports = __webpack_public_path__ + "static/media/008-emoji-6.4cea71af.svg";